import { render, staticRenderFns } from "./VisitsApproval.vue?vue&type=template&id=7eda2a15"
import script from "./VisitsApproval.vue?vue&type=script&lang=ts"
export * from "./VisitsApproval.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports